import { en, nl } from '@formkit/i18n'
import { genesisIcons } from '@formkit/icons'
import { defineFormKitConfig } from '@formkit/vue'

// Registers the built-in nl/en validation-message translations (replaces the removed
// @braid/vue-formulate-i18n en/nl locale plugins from the retired config/formulate.js).
// The Genesis theme's CSS is imported globally in nuxt.config.js's `css` array (bundled locally, not
// from FormKit's CDN, which is known to be flaky); this only wires up which theme name the generated
// class names use.
export default defineFormKitConfig({
  locale: 'nl',
  locales: { nl, en },
  theme: 'genesis',
  // Without this, icons (checkbox/radio decorators, select caret, etc.) are fetched one-by-one from
  // FormKit's CDN at runtime. SSR can't wait for that fetch, so the icon-bearing elements render
  // differently server- vs client-side, causing a Vue hydration mismatch on every icon-bearing input.
  // genesisIcons bundles exactly the icon set Genesis needs, resolved synchronously, no network call.
  icons: genesisIcons,
})
